<template>
  <div>
    <!-- Photo Journey -->
    <div @click="viewMore" class="card-measure card-measure--photo-journey">
      <div>
        <p class="card-measure__title">{{$t('message["fitness-diary.photo-journey"]')}}</p>
        <div class="card-measure__add-button" v-if="!isEditable" v-on:click.stop="showPhotoUpload()">
          <icon-forward  size="sm1"></icon-forward>
        </div>
        <div class="card-measure__add-button" v-else v-on:click.stop="showPhotoUpload()">
          <a :href="void(0)">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="btn-add-entry"
                d="M18.5098 12.0192H12.9809V6.73077C12.9809 6.4649 12.7655 6.25 12.5001 6.25C12.2348 6.25 12.0194 6.4649 12.0194 6.73077V12.0192H6.49053C6.22515 12.0192 6.00977 12.2341 6.00977 12.5C6.00977 12.7659 6.22515 12.9808 6.49053 12.9808H12.0194V18.75C12.0194 19.0159 12.2348 19.2308 12.5001 19.2308C12.7655 19.2308 12.9809 19.0159 12.9809 18.75V12.9808H18.5098C18.7751 12.9808 18.9905 12.7659 18.9905 12.5C18.9905 12.2341 18.7751 12.0192 18.5098 12.0192Z"
                fill="#868686"
              />
            </svg>
          </a>
        </div>
      </div>
      <div  v-if="state==='loaded'&&(showFirstImages||showLatestImages)">

        <div class="card-measure__before" v-if="showFirstImages">
          <p class="card-measure__second-title" v-if="latest.date && !(latest.date === first.date)">
            {{$t('message["fitness-diary.before"]')}} - {{first.date}}</p>
          <p class="card-measure__second-title" v-else>{{first.date}}</p>
          <div class="row">
            <div  :style="{visibility: image.image&&image.show ? 'visible' : 'hidden'}"
                 class="col-4 card-measure__images-wrap" v-bind:key="'beforeImage'+index" v-for="(image, index) in first.images">
              <LoadingBuffer height="160" v-show="image.state==='loading'"/>
              <img
                v-on:error="hideLoadingFirstImage(index)"
                alt=""
                class="card-measure__images"
                :src="image.image"
                v-on:load="hideLoadingFirstImage(index)"
                v-show="state!=='loading'"
              />
            </div>
          </div>
        </div>
        <div class="card-measure__now" v-if="showLatestImages ">
          <p class="card-measure__second-title">{{$t('message["fitness-diary.now"]')}} - {{latest.date}}</p>
          <div class="row">
            <div :style="{visibility: image.image&&image.show ? 'visible' : 'hidden'}"
                 class="col-4 card-measure__images-wrap"
                 v-for="(image, index) in latest.images"
                 :key="'card-measure__images'+index"
            >
              <LoadingBuffer height="160" v-show="state==='loading'"/>
              <img
                v-on:error="hideLoadingLatestImage(index)"
                alt=""
                v-bind:key="'afterImage'+index"
                class="card-measure__images"
                :src="image.image"
                v-on:load="hideLoadingLatestImage(index)"
                v-show="state!=='loading'"
              />
            </div>
          </div>
        </div>
        <div class="card-measure__more-button" v-if="isEditable">
         <p class="card-measure__more-link">{{$t('message["general.more"]')}} ></p>
        </div>
      </div>
      <div v-else-if="state==='init'">
        <div class="card-measure--first-time p-4">
          <p class="card-measure__info">
            {{$t('message["general.loading"]')}}...
          </p>
          <br><br>
        </div>
        <div v-if="isEditable" @click="viewMore" class="card-measure__more-button">
           <p class="card-measure__more-link">{{ $t('message["general.more"]') }} ></p>
        </div>
      </div>
      <div v-else>
        <div class="card-measure--first-time p-4">
          <p class="card-measure__info">
            {{$t('message["fitness-diary.photo-journey-description"]')}}
          </p>
        </div>
        <div v-if="isEditable" @click="viewMore"  class="card-measure__more-button">
           <p class="card-measure__more-link">{{ $t('message["general.more"]') }} ></p>
        </div>
      </div>
    </div>
    <pop-up-upload-photos :visible="uploadPopup.show" v-if="uploadPopup.show" v-on:close="uploadPopup.show=false"
                          v-on:uploaded="setPageData($event)"></pop-up-upload-photos>
  </div>
</template>

<script>
import PopUpUploadPhotos from '../../../../global/popups/PopUpUploadPhotos'
import LoadingBuffer from '../../global/widgets/LoadingBuffer'
import fitnessDiaryPhotoJourneySummaryMixin
  from '../../../../../mixins/component-mixins/page/fitness-diary/fitnessDiaryPhotoJourneySummaryMixin'
import IconForward from '../../../../root/icons/IconForward'

export default {
  name: 'PhotoJourneyCard',
  components: { IconForward, PopUpUploadPhotos, LoadingBuffer },
  mixins: [fitnessDiaryPhotoJourneySummaryMixin],
  mounted () {
    this.setPageData()
  }

}
</script>

<style scoped>

</style>
